import { useMemo } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/it';

/**
 * Hook personalizzato per generare le opzioni dei mesi per l'iscrizione ai corsi
 * @param {Object} course - Oggetto corso con startDate
 * @returns {Array} Array di opzioni con value e label
 */
const useMonthOptions = (course) => {
  const monthOptions = useMemo(() => {
    if (!course?.startDate) return [];
    
    const courseStartDate = dayjs(course.startDate);
    const currentDate = dayjs();
    
    const options = [];
    
    // Se currentDate è prima dell'inizio corso... solo il mese di course StartDate
    if (currentDate.isBefore(courseStartDate)) {
      const courseStartMonth = courseStartDate.startOf('month');
      options.push({
        value: courseStartMonth.format('YYYY-MM-DD'),
        label: courseStartMonth.locale('it').format('MMMM YYYY')
      });
    } else {
      // Altrimenti sono tutti i mesi da course startDate fino al mese corrente
      const courseStartMonth = courseStartDate.startOf('month');
      const currentMonth = currentDate.startOf('month');
      
      let monthToAdd = courseStartMonth;
      
      while (monthToAdd.isBefore(currentMonth) || monthToAdd.isSame(currentMonth)) {
        options.push({
          value: monthToAdd.format('YYYY-MM-DD'),
          label: monthToAdd.locale('it').format('MMMM YYYY')
        });
        monthToAdd = monthToAdd.add(1, 'month');
      }
    }
    
    return options;
  }, [course?.startDate]);

  return monthOptions;
};

export default useMonthOptions;
